import axios from "axios";
import { Base_URL } from "../url";

export const saveCompanyLocation = async (companyLocationData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CompanyLocationMaster?UserName=${userName}`,
      companyLocationData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving company location details!";
  }
};

export const getAllCompanyCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CompanyCode/GetAll`, {
      headers: { "Content-Type": "application/json" },
    });
    console.log("Company Code API Response:", response.data); // Debug
    return response.data || [];
  } catch (error) {
    console.error("Error fetching company codes:", error);
    return [];
  }
};
